import React, { useState } from 'react';
import styles from './bankSearchList.module.scss';
import { useTranslation } from 'react-i18next';
import { INITIAL_ITEMS_NUMBER } from '../../constants/bankSelectConstants';
import Spinner from '../spinner/Spinner';
import BankListRow from './BankListRow';
import LinkButton from '../buttons/LinkButton';
import SearchFeedback from './SearchFeedback';
import FeatherIcon from 'feather-icons-react';
import { IBankDto } from '../../domain/dto/IBankDto';
import { buildZendeskSupportUrl } from '../../utils/supportLinks';

interface IProps {
  data: IBankDto[];
  onSelect: (brandId: number) => void;
  isLoading: boolean;
  searchTerm?: string;
}

const BankSearchList: React.FC<IProps> = props => {
  const { data, onSelect, isLoading } = props;
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);

  if (isLoading) {
    return (
      <div className={`h-full grid place-content-center text-center`}>
        <Spinner /> <span className="mt-2">{t('Loading...')}</span>
      </div>
    );
  }

  const numberOfItems = showAll ? data?.length : INITIAL_ITEMS_NUMBER;

  return (
    <div
      className={`${data.length < 1 && 'flex flex-col justify-center items-center grow gap-2'}`}
      data-testid="bank-search-list-component"
    >
      <SearchFeedback count={data?.length} searchTerm={props.searchTerm} />
      {data.length > 0 && <div className={styles.list} data-testid="bank-tiles-list">
        {data?.slice(0, numberOfItems).map(item => (
          <BankListRow
            key={item.brandId}
            to={item.providers.length > 1 ? '/provider-selection' : '/consent'}
            label={item.name}
            logoUrl={item.logoUrl}
            onClick={() => onSelect(item.brandId)}
          />
        ))}
      </div>}

      {!showAll && data?.length > INITIAL_ITEMS_NUMBER && (
        <LinkButton onClick={() => setShowAll(!showAll)}>
          <div className={styles.seeMoreButtonWrapper}>
            <FeatherIcon icon="chevron-down" /> {t<string>('See more banks')}
          </div>
        </LinkButton>
      )}
      <a
        href={buildZendeskSupportUrl()}
        rel="noreferrer"
        target="_blank"
        className="underline text-gray-500 text-md text-center block"
      >
        {t(`My bank isn't listed`)}
      </a>
    </div>
  );
};

export default BankSearchList;
